import editLifeTime from '../../apis/editLifeTime'
import getTimeOut from '../../apis/getTimeOut'
import pen from '../../assets/icons/pen.svg'
import reset from '../../assets/icons/undo.svg'
import React, { useCallback, useEffect, useState } from 'react'

const SessionLifeTime = () => {
  const [update, setUpdate] = useState(false)
  const [lifeTime, setLifeTime] = useState('')
  const [initlLifeTime, setInitlLifeTime] = useState('')
  const [initloading, seInittLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errro, setError] = useState('')

  const fetchlifetime = useCallback(async () => {
    seInittLoading(true)
    try {
      const lifetimedata = await getTimeOut()
      setLifeTime(lifetimedata.session_lifetime)
      setInitlLifeTime(lifetimedata.session_lifetime)
    } catch (error) {
      console.error('Failed to fetch categories', error)
    } finally {
      seInittLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchlifetime()
  }, [fetchlifetime])

  const handelReset = () => {
    if (update) {
      setLifeTime(initlLifeTime)
    }
    setUpdate(!update)
  }

  const handelUpdateLifeTime = async () => {
    setLoading(true)
    try {
      await editLifeTime(lifeTime)
      fetchlifetime()
    } catch (error) {
      setError('error changing lif time')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className=" w-full flex justify-start gap-5 items-center ">
      <div className="w-1/3 rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
        <input
          required
          onChange={(e) => setLifeTime(e.target.value)}
          disabled={!update}
          value={initloading ? 'loading...' : lifeTime}
          className="w-full focus:outline-none"
          placeholder="Session Time"
          name="lifeTime"
          id="lifeTime"
        />
      </div>
      <div>
        <img
          src={update ? reset : pen}
          onClick={handelReset}
          alt=""
          className=" w-8 p-2 h-8 rounded border-[1px]"
        />
      </div>
      <button
        disabled={loading || initloading || !update}
        onClick={handelUpdateLifeTime}
        className="flex gap-2 justify-center items-center py-2 px-5 disabled:bg-blueButton/60 bg-blueButton transition-all duration-300 text-xl hover:scale-105 text-white text-center rounded-xl"
      >
        <span>{loading ? 'updating' : 'update'}</span>
      </button>
      {errro && (
        <div className=" p-2 bg-red/30 text-red text-center rounded">
          {errro}
        </div>
      )}
    </div>
  )
}

export default SessionLifeTime
